import { Component, Input } from '@angular/core';
import { LoadingService } from 'ng-devui';
import { NzMessageService } from 'ng-zorro-antd/message';
import { catchError, finalize, throwError } from 'rxjs';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { TableColumnOption } from 'src/app/modules/shared/components/table-pro/table.config';
import {
  ArchiveCatalogNameDynamicSmallTypeList,
  ArchiveCatalogNameDynamicTypeList,
} from 'src/app/modules/shared/models/archive/archive-catalog-name-dynamic-type.enum';
import { ArchiveCatalogNameRule } from 'src/app/modules/shared/models/archive/archive-catalog-name-rule.model';
import { ArchiveCatalogNameSeqTypeList } from 'src/app/modules/shared/models/archive/archive-catalog-name-seq-type.enum';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileSyncRuleType } from 'src/app/modules/shared/models/archive/archive-file-sync-rule-type.enum';
import { ArchiveKeepPeriodTypeOptions } from 'src/app/modules/shared/models/archive/archive-keep-period-type.enum';
import {
  ArchiveMaterialOrderFieldOptions,
  ArchiveOrderField,
  ArchiveOrderFieldMap,
  ArchiveRegularOrderFieldOptions,
  ArchiveWBSOrderFieldOptions,
} from 'src/app/modules/shared/models/archive/archive-order-field.enum';
import { ArchiveSortRuleInfo } from 'src/app/modules/shared/models/archive/archive-sort-rule-info.model';
import { ArchiveTitleRuleItemInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-info.model';
import { ArchiveTitleRuleItemParamInfo } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-info.model';
import { ArchiveTitleRuleItemParamType } from 'src/app/modules/shared/models/archive/archive-title-rule-item-param-type.enum';
import {
  ArchiveTitleRuleItemDisplayType,
  ArchiveTitleRuleItemType,
} from 'src/app/modules/shared/models/archive/archive-title-rule-item-type.enum';
import { ArchiveTitleRule } from 'src/app/modules/shared/models/archive/archive-title-rule.model';
import { ArchiveVolumeCreateType } from 'src/app/modules/shared/models/archive/archive-volume-create-type.enum';
import {
  ArchiveVolumeFileRule,
  ArchiveVolumeFileRuleMap,
} from 'src/app/modules/shared/models/archive/archive-volume-file-rule.enum';
import { ArchiveVolumeRuleType } from 'src/app/modules/shared/models/archive/archive-volume-rule-type.enum';
import { ArchiveVolumeRule } from 'src/app/modules/shared/models/archive/archive-volume-rule.model';
import { ArchiveVolumeType } from 'src/app/modules/shared/models/archive/archive-volume-type.enum';
import { ArchiveVolume } from 'src/app/modules/shared/models/archive/archive-volume.model';
import {
  BatchMaterialArchiveVolumnTypeList,
  BatchRegularArchiveVolumnType,
  BatchRegularArchiveVolumnTypeList,
  BatchWBSArchiveVolumnType,
  BatchWBSArchiveVolumnTypeList,
} from 'src/app/modules/shared/models/archive/batch-archive-catelog-rule-type.enum';
import { MaterialType } from 'src/app/modules/shared/models/material/material-type.model';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItem } from 'src/app/modules/shared/models/project/project-section-item.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { ArchiveFileService } from 'src/app/modules/shared/services/archive-file.service';
import { ArchiveVolumeRuleService } from 'src/app/modules/shared/services/archive-volume-rule.service';
import { ArchiveVolumeService } from 'src/app/modules/shared/services/archive-volume.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import {
  getWbsSectionItemIds,
  getWbsSectionOptions,
  updateWbsSelectionRows,
} from '../wbs-section-selection.utils';
import {
  ArchiveVolumePageType,
  ArchiveVolumePageTypeOptions,
} from './../../../../shared/models/archive/archive-volume-page-type.enum';
import { BatchArchiveVolume } from './../../../../shared/models/archive/batch-archive-volume.model';

@Component({
  selector: 'app-dialog-projects-profiles-volumn-add',
  templateUrl: './dialog-projects-profiles-volumn-add.component.html',
  styleUrls: ['./dialog-projects-profiles-volumn-add.component.scss'],
})
export class DialogProjectsProfilesVolumnAddComponent {
  /**
   * 一个新需求，涉及范围 DialogProjectsProfilesVolumnAddComponent
   * 选择本卷对应WBS工程部位，以确定归卷文件范围：（1）可以选择多个部位，每选一个部位，则自动往下插入空白待选行（2）已选择部位，允许通过“×“删除本行（3）在选择框中，已经被上方行选中的选项，将Disable（避免重复选择）（4）为空：表示不通过这种方式划定归卷文件范围
   */
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  editing: { [name: string]: boolean } = {};

  record: BatchArchiveVolume = new BatchArchiveVolume();

  catalog: ArchiveCatalog = new ArchiveCatalog();

  sectionNodes: Array<NzTreeNode> = [];

  materialTypeList = [] as Array<MaterialType>;

  canBatch = true;

  ArchiveVolumeCreateType = ArchiveVolumeCreateType;

  BatchArchiveVolumeRuleList: TableColumnOption[] = [];

  ArchiveVolumePageTypeOptions = ArchiveVolumePageTypeOptions;

  ArchiveVolumePageType = ArchiveVolumePageType;

  ArchiveKeepPeriodTypeOptions = ArchiveKeepPeriodTypeOptions;

  batchRule = '';

  sortOrder: ArchiveOrderField[] = [];

  ArchiveOrderFieldOptions: TableColumnOption[] = [];

  ArchiveVolumeFileRule = ArchiveVolumeFileRule;

  ArchiveVolumeFileRuleMap = ArchiveVolumeFileRuleMap;

  titleRule = new ArchiveTitleRule();

  ruleItemMap: { [key: string]: ArchiveTitleRuleItemParamInfo } = {};

  ArchiveTitleRuleItemDisplayType = ArchiveTitleRuleItemDisplayType;

  ArchiveTitleRuleItemParamType = ArchiveTitleRuleItemParamType;

  parentSectionItem?: ProjectSectionItem;

  volumeType: ArchiveVolumeType = ArchiveVolumeType.REGULAR;

  ArchiveVolumeType = ArchiveVolumeType;

  get autoCount() {
    switch (this.volumeType) {
      case ArchiveVolumeType.WBS:
        return 11;
      case ArchiveVolumeType.MATERIAL:
        return 8;
      case ArchiveVolumeType.REGULAR:
        return 8;
    }
  }

  onBatchChange() {
    this.batchRule = '';
    if (this.record.createType === ArchiveVolumeCreateType.MANUAL) {
      this.record.ruleType = ArchiveVolumeRuleType.NONE;
      if (this.volumeType === ArchiveVolumeType.WBS) {
        this.record.fileRule = ArchiveVolumeFileRule.SELECT_WBS;
      } else {
        this.record.fileRule = ArchiveVolumeFileRule.NONE;
      }
    } else {
      if (this.volumeType === ArchiveVolumeType.WBS) {
        this.record.ruleType = ArchiveVolumeRuleType.WBS;
        console.log(this.parentSectionItem);
        const rules = JSON.parse(JSON.stringify(BatchWBSArchiveVolumnTypeList));
        if (
          !(
            this.parentSectionItem?.fullCode!.includes('J') ||
            this.parentSectionItem?.fullCode!.includes('L')
          )
        ) {
          rules.pop();
          rules.pop();
        }
        let sub = 0;
        if (this.parentSectionItem?.type === ProjectItemType.DW) {
        } else if (this.parentSectionItem?.type === ProjectItemType.FB) {
          sub = 1;
        } else if (this.parentSectionItem?.type === ProjectItemType.SUB_FB) {
          sub = 2;
        } else if (this.parentSectionItem?.type === ProjectItemType.FX) {
          sub = 3;
        } else if (this.parentSectionItem?.type === ProjectItemType.SECTION) {
          sub = 4;
        } else if (this.parentSectionItem?.type === ProjectItemType.SEGMENT) {
          sub = 5;
        } else if (this.parentSectionItem?.type === ProjectItemType.LAYER) {
          sub = 6;
        }
        if (sub > 0) {
          this.BatchArchiveVolumeRuleList = rules.slice(sub);
        } else {
          this.BatchArchiveVolumeRuleList = rules;
        }
      } else if (this.volumeType === ArchiveVolumeType.MATERIAL) {
        this.BatchArchiveVolumeRuleList = BatchMaterialArchiveVolumnTypeList;
      } else {
        this.BatchArchiveVolumeRuleList = BatchRegularArchiveVolumnTypeList;
      }
    }
  }

  onBatchRuleChange() {
    if (this.record.ruleType === ArchiveVolumeRuleType.WBS) {
      switch (this.batchRule) {
        case BatchWBSArchiveVolumnType.WBS_DW:
          this.record.ruleCode = ProjectItemType.DW.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_FB:
          this.record.ruleCode = ProjectItemType.FB.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_SUB_FB:
          this.record.ruleCode = ProjectItemType.SUB_FB.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_FX:
          this.record.ruleCode = ProjectItemType.FX.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_SECTION:
          this.record.ruleCode = ProjectItemType.SECTION.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_SEGMENT:
          this.record.ruleCode = ProjectItemType.SEGMENT.toString();
          break;
        case BatchWBSArchiveVolumnType.WBS_LAYER:
          this.record.ruleCode = ProjectItemType.LAYER.toString();
          break;
      }
    } else if (this.volumeType === ArchiveVolumeType.MATERIAL) {
      this.record.ruleType = ArchiveVolumeRuleType.MATERIAL;
      if (this.batchRule) {
        this.record.ruleCode = this.batchRule.toString();
      } else {
        this.record.ruleType = ArchiveVolumeRuleType.NONE;
        this.record.ruleCode = undefined;
      }
    } else {
      this.record.ruleType = ArchiveVolumeRuleType.SECTION;
      this.record.ruleCode = undefined;
      switch (this.batchRule) {
        // case BatchRegularArchiveVolumnType.MATERIAL_TYPE:
        //   this.record.ruleType = ArchiveVolumeRuleType.MATERIAL;
        //   break;
        case BatchRegularArchiveVolumnType.CONSTRUCTION_SECTION:
          this.record.ruleCode = OrganizationType.CONSTRUCTION.toString();
          break;
        case BatchRegularArchiveVolumnType.SUPERVISE_SECTION:
          this.record.ruleCode = OrganizationType.SUPERVISE.toString();
          break;
        case BatchRegularArchiveVolumnType.SPOT_CHECK_SECTION:
          this.record.ruleCode = OrganizationType.SPOT_CHECK.toString();
          break;
        case BatchRegularArchiveVolumnType.JG_CHECK_SECTION:
          this.record.ruleCode = OrganizationType.JG_CHECK.toString();
          break;
        case BatchRegularArchiveVolumnType.COMPLETED_CHECK_SECTION:
          this.record.ruleCode = OrganizationType.COMPLETED_CHECK.toString();
          break;
        default:
          this.record.ruleType = ArchiveVolumeRuleType.NONE;
          break;
      }
    }
  }

  onPageLimitChange() {
    this.record.volumePageLimit = undefined;
  }

  ArchiveCatalogNameSeqTypeList = ArchiveCatalogNameSeqTypeList;

  ArchiveCatalogNameDynamicTypeList = ArchiveCatalogNameDynamicTypeList;

  ArchiveCatalogNameDynamicSmallTypeList =
    ArchiveCatalogNameDynamicSmallTypeList;

  nameRule = new ArchiveCatalogNameRule();

  exampleName = '';

  sectionMap: { [key: string]: ProjectSection } = {};

  unitCascaderValues: string[][] = [[]];

  unitCascaderOptions: NzTreeNode[][] = [[]];

  fileCodeOrder: TableColumnOption[] = [];

  fileOrder: string[] = [];

  fileOrderEnabled = false;

  forms: { code: string; name: string }[] = [];

  constructor(
    private projectSectionItemService: ProjectSectionItemService,
    private archiveVolumeRuleService: ArchiveVolumeRuleService,
    private archiveVolumeService: ArchiveVolumeService,
    private archiveFileService: ArchiveFileService,
    private message: NzMessageService,
    private globalService: GlobalService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit() {
    this.handleDataBeforeInit(this.data.data!);
    this.getSectionItem();
  }

  private getSectionItem() {
    if (this.catalog.sectionId) {
      this.projectSectionItemService
        .tree({
          projectId: this.globalService.projectId,
          type: ProjectItemType.SECTION,
          sectionId: this.catalog.sectionId,
        })
        .subscribe((res) => {
          let node = new ProjectSectionItem();
          if (this.catalog.sectionItemId) {
            for (const child of res.child ?? []) {
              const found = this.searchTreeNode(
                this.catalog.sectionItemId,
                child,
              );
              if (!!found) {
                node = found;
              } else {
                node = res.child![0];
              }
            }
          } else {
            node = res.child![0];
          }
          this.parentSectionItem = node;
          const treeNode: NzTreeNode[] = [];
          treeNode.push(this.buildTreeNodes(node, true));
          this.sectionNodes = treeNode;
          this.refreshUnitCascaderOptions();
        });
    }
    if (!this.catalog.volumeCount || this.catalog.volumeCount === 0) {
      this.archiveVolumeRuleService
        .findOne({
          catalogId: this.catalog.parentId,
        })
        .subscribe((res: ArchiveVolumeRule) => {
          if (res) {
            this.titleRule.titleFixedSuffix = res.titleFixedSuffix;
            this.titleRule.titleFixedPrefix = res.titleFixedPrefix;
            for (const item of res.titleAutoParts || []) {
              for (const param of item.params ?? []) {
                let key = `${item.type}_${param.type}`;
                if (item.type === ArchiveTitleRuleItemType.MATERIAL) {
                  key = `${item.formHeaderName}_${param.type}`;
                }
                if (!!this.ruleItemMap[key]) {
                  this.ruleItemMap[key].checked = param.checked;
                  this.ruleItemMap[key].separator = param.separator;
                }
              }
            }
            this.record.ruleType = res.ruleType;
            this.record.ruleCode = res.ruleCode;
            this.record.volumePageType = res.volumePageType;
            this.record.volumePageLimit = res.volumePageLimit;
            this.record.keepPeriodType = res.keepPeriodType;
            this.record.fileRule = res.fileRule ?? ArchiveVolumeFileRule.NONE;
            this.sortOrder = res.volumeSortRules
              ?.sort((a, b) => a.order! - b.order!)
              .map((x) => x.orderField) as ArchiveOrderField[];
            this.fileOrder = res.volumeSortRules?.find(
              (x) => x.orderField === ArchiveOrderField.FORM_CODE,
            )?.formCodes as string[];
            this.onOrderSelected();
          }
        });
    }
    if (this.volumeType === ArchiveVolumeType.REGULAR) {
      this.archiveFileService
        .listFormInfoByCatalogId(this.catalog.id!)
        .subscribe((res) => {
          const fileOrder: TableColumnOption[] = [];
          for (const file of res) {
            fileOrder.push({
              label: (file.code ?? '') + ' ' + (file.name ?? ''),
              value: file.code!,
            });
          }
          this.fileCodeOrder = fileOrder;
          this.forms = res;
        });
    }
  }

  genExampleName() {
    setTimeout(() => {
      let exampleName = '';
      for (const mainType of Object.keys(ArchiveTitleRuleItemDisplayType)) {
        for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
          let part = '';
          if (paramType === ArchiveTitleRuleItemParamType.ITEM_NAME) {
            switch (mainType) {
              case ArchiveTitleRuleItemDisplayType.PROJECT:
                part = '104国道杭州河庄至衙前段';
                break;
              case ArchiveTitleRuleItemDisplayType.DESIGN:
                part = '杭州市交通规划设计研究院有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.SUPERVISION:
                part = '杭州交通工程监理咨询有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.CONSTRUCTION:
                part = '浙江交工集团股份有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.SPOT_CHECK:
                part = '杭州市交通工程试验检测中心有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.JG_CHECK:
                part = '中路高科交通检测检验认证有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK:
                part = '绍兴市交科工程检测有限公司';
                break;
              case ArchiveTitleRuleItemDisplayType.MATERIAL_TYPE:
                part = '水泥';
                break;
              case ArchiveTitleRuleItemDisplayType.MATERIAL_MODEL:
                part = 'HPB300Φ10';
                break;
              case ArchiveTitleRuleItemDisplayType.MATERIAL_YEAR:
                part = '10';
                break;
              case ArchiveTitleRuleItemDisplayType.DW:
                part = '主线高架桥(K4+658.396-K6+163.539)';
                break;
              case ArchiveTitleRuleItemDisplayType.FB:
                part = '基础及下部构造（188#~200#墩）';
                break;
              case ArchiveTitleRuleItemDisplayType.SUB_FB:
                part = '188#墩基础';
                break;
              case ArchiveTitleRuleItemDisplayType.FX:
                part = '钻孔灌注桩';
                break;
              case ArchiveTitleRuleItemDisplayType.SECTION:
                part = '188-1#桩基';
                break;
              default:
                part = '';
                break;
            }
          } else {
            switch (mainType) {
              case ArchiveTitleRuleItemDisplayType.DESIGN:
                part = 'SJ-01';
                break;
              case ArchiveTitleRuleItemDisplayType.SUPERVISION:
                part = 'XSJL-01';
                break;
              case ArchiveTitleRuleItemDisplayType.CONSTRUCTION:
                part = 'EPC-02';
                break;
              case ArchiveTitleRuleItemDisplayType.SPOT_CHECK:
                part = 'SY-01';
                break;
              case ArchiveTitleRuleItemDisplayType.JG_CHECK:
                part = 'JGJC-01';
                break;
              case ArchiveTitleRuleItemDisplayType.COMPLETED_CHECK:
                part = 'JG-01';
                break;
              case ArchiveTitleRuleItemDisplayType.DW:
                part = 'Q01';
                break;
              case ArchiveTitleRuleItemDisplayType.FB:
                part = '01';
                break;
              case ArchiveTitleRuleItemDisplayType.SUB_FB:
                part = '02';
                break;
              case ArchiveTitleRuleItemDisplayType.FX:
                part = '03';
                break;
              case ArchiveTitleRuleItemDisplayType.SECTION:
                part = '04';
                break;
              case ArchiveTitleRuleItemDisplayType.SEGMENT:
                part = 'D1';
                break;
              case ArchiveTitleRuleItemDisplayType.LAYER:
                part = 'C1';
                break;
              default:
                part = '';
                break;
            }
          }
          const key = `${mainType}_${paramType}`;
          if (!!this.ruleItemMap[key] && !!this.ruleItemMap[key].checked) {
            if (!!this.ruleItemMap[key].separator) {
              part += this.ruleItemMap[key].separator;
            }
            exampleName += part;
          }
        }
      }
      this.exampleName = `${
        this.titleRule.titleFixedPrefix ?? ''
      }${exampleName}${this.titleRule.titleFixedSuffix ?? ''}`;

      // 不要删。下面这段代码是为了确保变更检测机制能检测到titleRule的变化，从而更新界面显示的值。
      const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
      for (const mainType of Object.keys(ArchiveTitleRuleItemDisplayType)) {
        const info = new ArchiveTitleRuleItemInfo();
        if (mainType.includes('MATERIAL')) {
          info.type = ArchiveTitleRuleItemType.MATERIAL;
          info.formHeaderName = mainType;
        } else {
          info.type = mainType as ArchiveTitleRuleItemType;
        }
        info.params = [];
        for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
          const key = `${mainType}_${paramType}`;
          if (!!this.ruleItemMap[key] && this.ruleItemMap[key].checked) {
            info.params.push(this.ruleItemMap[key]);
          } else {
            info.params.push({
              checked: false,
              type: paramType as ArchiveTitleRuleItemParamType,
            });
          }
        }
        if (info.params.length > 0) {
          titleAutoParts.push(info);
        }
      }
      this.titleRule.titleAutoParts = titleAutoParts;
      this.record.titleRule = this.titleRule;
    }, 50);
  }

  private handleDataBeforeInit(response: ArchiveCatalog) {
    this.catalog = JSON.parse(JSON.stringify(response)) as ArchiveCatalog;
    this.canBatch = !this.catalog.volumeCount;
    if (!!this.catalog.sectionItemId || !!this.catalog.dwTypeCode) {
      this.volumeType = ArchiveVolumeType.WBS;
    }
    for (const rule of this.catalog.fileSyncRules ?? []) {
      if (
        rule.type === ArchiveFileSyncRuleType.MATERIAL &&
        rule.content &&
        rule.checked
      ) {
        this.volumeType = ArchiveVolumeType.MATERIAL;
      }
    }
    this.record.projectId = this.globalService.projectId;
    this.record.catalogId = this.catalog.id;
    console.log('catalog in dialog:', this.catalog);
    switch (this.volumeType) {
      case ArchiveVolumeType.WBS:
        this.ArchiveOrderFieldOptions = ArchiveWBSOrderFieldOptions;
        break;
      case ArchiveVolumeType.MATERIAL:
        this.ArchiveOrderFieldOptions = ArchiveMaterialOrderFieldOptions;
        break;
      default:
        this.ArchiveOrderFieldOptions = ArchiveRegularOrderFieldOptions;
        break;
    }
    for (const mainType of Object.keys(ArchiveTitleRuleItemDisplayType)) {
      for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
        const key = `${mainType}_${paramType}`;
        this.ruleItemMap[key] = new ArchiveTitleRuleItemParamInfo();
        this.ruleItemMap[key].mainType =
          ArchiveTitleRuleItemDisplayType[
            mainType as keyof typeof ArchiveTitleRuleItemDisplayType
          ];
        this.ruleItemMap[key].type =
          ArchiveTitleRuleItemParamType[
            paramType as keyof typeof ArchiveTitleRuleItemParamType
          ];
      }
    }
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.PROJECT}_${ArchiveTitleRuleItemParamType.ITEM_SN}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.SEGMENT}_${ArchiveTitleRuleItemParamType.ITEM_NAME}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.LAYER}_${ArchiveTitleRuleItemParamType.ITEM_NAME}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.MATERIAL_TYPE}_${ArchiveTitleRuleItemParamType.ITEM_SN}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.MATERIAL_MODEL}_${ArchiveTitleRuleItemParamType.ITEM_SN}`
    ];
    delete this.ruleItemMap[
      `${ArchiveTitleRuleItemDisplayType.MATERIAL_YEAR}_${ArchiveTitleRuleItemParamType.ITEM_SN}`
    ];
    this.onBatchChange();
  }

  private buildTreeNodes(
    item: ProjectSectionItem,
    hasAllNode?: boolean,
  ): NzTreeNode {
    const node: NzTreeNode = {
      label:
        item.type !== ProjectItemType.PROJECT_SECTION
          ? item.code + ' ' + item.name
          : item.name,
      value: `${item.type}#${item.id}`,
      children: [],
      isLeaf: false,
    };
    for (const child of item.child ?? []) {
      if (
        item.type === ProjectItemType.PROJECT_SECTION &&
        !!this.catalog.dwTypeCode
      ) {
        if (child.code && child.code.indexOf(this.catalog.dwTypeCode) >= 0) {
          node.children!.push(this.buildTreeNodes(child, hasAllNode));
        }
      } else {
        node.children!.push(this.buildTreeNodes(child, hasAllNode));
      }
    }
    if (node.children?.length === 0) {
      node.isLeaf = true;
      node.children = undefined;
    } else if (hasAllNode) {
      node.children!.unshift({
        label: '全部',
        value: `${item.type}#${item.id}`,
        isLeaf: true,
      });
    }
    return node;
  }

  private searchTreeNode(
    sectionItemId: number,
    node: ProjectSectionItem,
  ): ProjectSectionItem | null {
    if (node.id === sectionItemId) {
      return node;
    }
    for (const child of node.child ?? []) {
      if (child.id === sectionItemId) {
        return child;
      } else {
        const found = this.searchTreeNode(sectionItemId, child);
        if (found) {
          // node.child = [found];
          return found;
        }
      }
    }
    return null;
  }

  onUnitCascaderChange(index: number, value: string[] | null) {
    this.unitCascaderValues = updateWbsSelectionRows(
      this.unitCascaderValues,
      index,
      value,
    );
    this.refreshUnitCascaderOptions();
  }

  removeUnitCascader(index: number) {
    this.onUnitCascaderChange(index, null);
  }

  private refreshUnitCascaderOptions() {
    this.unitCascaderOptions = this.unitCascaderValues.map((_, index) =>
      getWbsSectionOptions(this.sectionNodes, this.unitCascaderValues, index),
    );
  }

  onOrderSelected() {
    setTimeout(() => {
      const copy = JSON.parse(JSON.stringify(this.ArchiveOrderFieldOptions));
      for (const item of copy) {
        const index = this.sortOrder.indexOf(item.value as ArchiveOrderField);
        item.label =
          index >= 0
            ? `排序(${index + 1}) ${
                ArchiveOrderFieldMap[item.value as ArchiveOrderField]
              }`
            : ArchiveOrderFieldMap[item.value as ArchiveOrderField];
      }
      this.ArchiveOrderFieldOptions = copy;
      if (this.sortOrder.indexOf(ArchiveOrderField.FORM_CODE) < 0) {
        this.fileOrder = [];
        this.fileOrderEnabled = false;
      } else {
        this.fileOrderEnabled = true;
      }
    }, 50);
  }

  onFileOrderSelected() {
    setTimeout(() => {
      const copy = JSON.parse(JSON.stringify(this.fileCodeOrder));
      for (let i = 0; i < copy.length; i++) {
        const index = this.fileOrder.indexOf(copy[i].value.toString());
        copy[i].label =
          index >= 0
            ? `排序(${index + 1}) ${this.forms[i].code} ${this.forms[i].name}`
            : `${this.forms[i].code} ${this.forms[i].name}`;
      }
      this.fileCodeOrder = copy;
    }, 50);
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm(saveOnly?: boolean) {
    this.submit(saveOnly);
  }

  private handleDataBeforeConfirm(
    response: BatchArchiveVolume,
  ): BatchArchiveVolume {
    const data = JSON.parse(JSON.stringify(response)) as BatchArchiveVolume;
    const sortRules: Array<ArchiveSortRuleInfo> = [];
    let index = 0;
    for (const orderField of this.sortOrder) {
      const rule: ArchiveSortRuleInfo = {
        orderField,
        orderType: OrderType.ASC,
        order: index++,
      };
      if (orderField === ArchiveOrderField.FORM_CODE) {
        rule.formCodes = this.fileOrder;
      }
      sortRules.push(rule);
    }
    data.sortRules = sortRules;
    data.sectionId = this.catalog.sectionId;
    if (
      data.createType === ArchiveVolumeCreateType.MANUAL &&
      this.volumeType === ArchiveVolumeType.WBS
    ) {
      data.sectionItemIds = getWbsSectionItemIds(this.unitCascaderValues);
    }

    if (this.catalog.dwTypeCode) {
      data.dwTypeCode = this.catalog.dwTypeCode;
    }

    if (
      data.fileRule === ArchiveVolumeFileRule.FULL_FILES &&
      data.createType === ArchiveVolumeCreateType.MANUAL &&
      this.volumeType !== ArchiveVolumeType.WBS
    ) {
      if (data.fileFinishDateFromDate && data.fileFinishDateToDate) {
        data.fileFinishDateFrom = new Date(
          data.fileFinishDateFromDate,
        ).getTime();
        data.fileFinishDateTo = new Date(data.fileFinishDateToDate).getTime();
      }
    }

    if (!data.sectionItemIds || data.sectionItemIds?.length === 0) {
      if (this.catalog.sectionItemId) {
        data.sectionItemIds = [this.catalog.sectionItemId];
      }
    }

    return data;
  }

  get canConfirm() {
    if (this.sortOrder.length === 0) {
      return false;
    }
    if (this.sortOrder.includes(ArchiveOrderField.FORM_CODE)) {
      if (!this.fileOrder || this.fileOrder.length === 0) {
        return false;
      }
    }
    if (this.record.volumePageType === ArchiveVolumePageType.LIMITED) {
      if (
        this.record.volumePageLimit === undefined ||
        this.record.volumePageLimit === null ||
        this.record.volumePageLimit <= 0 ||
        `${this.record.volumePageLimit}` === '' ||
        window.isNaN(this.record.volumePageLimit)
      ) {
        return false;
      }
    }
    if (
      this.record.createType === ArchiveVolumeCreateType.AUTO_BATCH &&
      !this.batchRule
    ) {
      return false;
    }
    if (this.record.createType === ArchiveVolumeCreateType.MANUAL) {
      if (!this.record.title || this.record.title.trim() === '') {
        return false;
      }
      // 此处不需要判断。可以为空
      // if (this.record.fileRule === ArchiveVolumeFileRule.SELECT_WBS) {
      //   if (this.unitCascaderValue.length === 0) {
      //     return false;
      //   }
      // }
      if (this.volumeType !== ArchiveVolumeType.WBS) {
        if (
          this.record.fileRule !== ArchiveVolumeFileRule.FULL_FILES &&
          this.record.fileRule !== ArchiveVolumeFileRule.MANUAL_SELECT
        ) {
          return false;
        }
      }
    }
    return true;
  }

  private submit(saveOnly?: boolean) {
    const loading = this.loadingService.open();
    const record = this.handleDataBeforeConfirm(this.record);
    if (record.createType === ArchiveVolumeCreateType.MANUAL) {
      record.ruleType = ArchiveVolumeRuleType.NONE;
      record.ruleCode = undefined;
      record.titleRule = undefined;
      this.archiveVolumeService
        .create(record as ArchiveVolume)
        .pipe(finalize(() => loading.loadingInstance.close()))
        .subscribe((response: ArchiveVolume) => {
          if (response) {
            this.data.onConfirm!(saveOnly);
            this.message.success('创建成功');
          }
        });
    } else {
      // 不要删。下面这段代码是为了确保变更检测机制能检测到titleRule的变化，从而更新界面显示的值。
      console.log('this.titleRule', this.titleRule);
      const titleAutoParts: Array<ArchiveTitleRuleItemInfo> = [];
      for (const mainType of Object.keys(ArchiveTitleRuleItemDisplayType)) {
        const info = new ArchiveTitleRuleItemInfo();
        if (mainType.includes('MATERIAL')) {
          info.type = ArchiveTitleRuleItemType.MATERIAL;
          info.formHeaderName = mainType;
        } else {
          info.type = mainType as ArchiveTitleRuleItemType;
        }
        info.params = [];
        for (const paramType of Object.keys(ArchiveTitleRuleItemParamType)) {
          const key = `${mainType}_${paramType}`;
          if (!!this.ruleItemMap[key] && this.ruleItemMap[key].checked) {
            info.params.push(this.ruleItemMap[key]);
          } else {
            info.params.push({
              checked: false,
              type: paramType as ArchiveTitleRuleItemParamType,
            });
          }
        }
        if (info.params.length > 0) {
          titleAutoParts.push(info);
        }
      }
      this.titleRule.titleAutoParts = titleAutoParts;
      record.titleRule = this.titleRule;
      this.archiveVolumeService
        .batchCreate(record)
        .pipe(finalize(() => loading.loadingInstance.close()))
        .subscribe((response: boolean) => {
          if (response) {
            this.data.onConfirm!();
          }
        });
    }
  }
}
